import { getAppInfo } from './base'
import { ROUTER_TYPE } from './constant'
export const isTaboolaRouter = () => {
    return getAppInfo().routerType === ROUTER_TYPE.TABOOLA
}

// 获取taboola配置
export const getTaboolaConfig = (idfp = 1) => {
    const { publisher_id, idfpConfig } = getAppInfo().taboolaConfig
    const { mode, placement } = idfpConfig[idfp] || idfpConfig[1]
    return {
        publisher_id,
        mode,
        placement,
    }
}

// 初始化taboola
export const initTaboola = () => {
    const { publisher_id } = getTaboolaConfig()
    window._taboola = window._taboola || [];
    _taboola.push({article:'auto'});
    // 注意：这里我们先不设置页面类型，因为在SPA中页面类型会变化，我们将在具体页面组件中设置
    !function (e, f, u, i) {
      if (!document.getElementById(i)){
        e.async = 1;
        e.src = u;
        e.id = i;
        f.parentNode.insertBefore(e, f);
      }
    }(document.createElement('script'),
    document.getElementsByTagName('script')[0],
    `//cdn.taboola.com/libtrc/${publisher_id}/loader.js`,
    'tb_loader_script');
    if(window.performance && typeof window.performance.mark == 'function')
      {window.performance.mark('tbl_ic');}
}
// 推送taboola广告
export const taboolaPushAd = (container) => {
    const { mode, placement } = getTaboolaConfig()
    window._taboola = window._taboola || [];
    _taboola.push({
        mode,
        container,
        placement,
        target_type: 'mix'
    });
    _taboola.push({flush: true});
}